module.exports = __webpack_public_path__ + "OpenSans-Italic-525074686dfb8aa36b1b92e29de467ac.woff";